import { useEffect, useState } from "react";
import styled from "styled-components";
import Bg from "../../assets/bg-grid.svg";
import BgTree from "../../assets/bg-tree2.png";
import MapBtn from "../../assets/map-btn.png";
import Text from "../../components/Text";
import Button from "../../components/Button";
import { GameWin } from "../../components/GameWin";


const LossPageWrapper = styled.div`
  height: 100%;
  width: 100%;
  background-color: #72969b;
  background-image: url(${Bg});
  background-position: center;
  background-size: cover;
  position: absolute;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: end;
   
  @media (max-width: 1024px) {
    overflow-y: auto ;
  }
`;

const ContentWrapper = styled.div`
  margin: 35px 200px 0 200px;
  width: 90%;
  height: 85%;
  background-color: #3e626a;
  background-image: url(${BgTree});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
  
   &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }
`;

const YellowLineExternal = styled.div`
  height: 97.3%;
  margin: 20px 20px 0 20px;
  border-top: 1px double var(--highlight);
  border-left: 1px double var(--highlight);
  border-right: 1px double var(--highlight);
`;

const YellowLineInternal = styled.div`
  height: 99.3%;
  margin: 5px 5px 0 5px;
  border-top: 1px double var(--highlight);
  border-left: 1px double var(--highlight);
  border-right: 1px double var(--highlight);
`;

const TextContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 70px;

  @media (max-width: 1500px) {
    margin-top: 50px;
  }
`;

const PointsContainer = styled.div`
  background-color: #fffbec;
  border-radius: 10px;
  height: 270px;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 50px;

  @media (max-width: 1500px) {
    margin-bottom: 20px;
  }
`;

export const CastleWinPage = () => {
  const [castlePoints, setCastlePoints] = useState(0);
  const [showGameWin, setShowGameWin] = useState(false);

  const finalCastleScore = parseInt(sessionStorage.getItem("last_castle_score") || "0", 10);
  const flawless = sessionStorage.getItem("flawless_bonus_applied") === "true";
  const audioCount = parseInt(sessionStorage.getItem("castle_audio_count") || "1", 10);
  const multiplier = audioCount === 2 ? 3 : 2;

  useEffect(() => {
    const allowReplay = sessionStorage.getItem("allow_replay_conquered") === "true";
    const conquered = JSON.parse(sessionStorage.getItem("conquered_castles") || "[]");
    const newlyConquered = JSON.parse(sessionStorage.getItem("newly_conquered_castles") || "[]");
    const failed = JSON.parse(sessionStorage.getItem("failed_castles") || "[]");
  
    const total = conquered.length + failed.length;
    const totalConquered = conquered.length;
  
    const gameWinCondition = allowReplay
      ? newlyConquered.length >= 9
      : total >= 11 && totalConquered >= 9;
  
    if (gameWinCondition) {
      setShowGameWin(true);
    }
  }, []);
  

  return (
    <LossPageWrapper>
      {showGameWin && <GameWin />}
    
      <ContentWrapper>
        <YellowLineExternal>
          <YellowLineInternal>
            <TextContainer>
              <Text
                fontFamily="'Source Serif 4'"
                fontSize="70px"
                fontWeight="700"
                color="#F3DE8A"
                lineheight="100%"
                padding="0 0 40px 0"
              >
                Συγχαρητήρια
              </Text>

              <Text
                fontFamily="Manrope"
                fontSize="20px"
                fontWeight="500"
                color="#F3DE8A"
                lineheight="100%"
                padding="0 0 50px 0"
              >
                Κατακτήσατε ένα κάστρο!
              </Text>

              <PointsContainer>
                {flawless && (
                  <Text
                    fontFamily="Manrope"
                    fontSize="20px"
                    fontWeight="500"
                    color="#3E626A"
                    lineheight="100%"
                  >
                    +50 Όλες σωστές
                  </Text>
                )}
                <Text
                  fontFamily="Manrope"
                  fontSize="20px"
                  fontWeight="500"
                  color="#3E626A"
                  lineheight="100%"
                >
                  x{multiplier} (Κάστρου)
                </Text>
                <Text
                  fontFamily="Manrope"
                  fontSize="40px"
                  fontWeight="700"
                  color="#3E626A"
                  lineheight="100%"
                >
                  {finalCastleScore}
                </Text>
              </PointsContainer>

              <Button imgurl={MapBtn} url="/play" />
            </TextContainer>
          </YellowLineInternal>
        </YellowLineExternal>
      </ContentWrapper>
    </LossPageWrapper>
  );
};
